import React from "react";
import { FormProvider } from "react-hook-form";
import {
  Alert,
  Box,
  Stack,
} from "@mui/material";
import {
  RFHAutocomplete,
  RFHTextField,
  RHFRadioGroup,
} from "../../../../components/RFH";
import { CustomButton } from "../../../../components/Button/Button";
import { inviteUserTypes } from "../../../../utils/constants/index.js";
import { useInviteUserForm } from "../hooks/useInviteUserForm";

function InviteUserForm({ onClose }) {
  const {
    apiError,
    tab,
    loading,
    userOptions,
    formMethods,
    handleSubmit,
    submit,
  } = useInviteUserForm({ onClose });
  const { ...methods } = formMethods;

  return (
    <FormProvider {...methods}>
      <Box
        component="form"
        onSubmit={handleSubmit(submit)}
        noValidate
        className="invite-user-form"
      >
        <RHFRadioGroup
          name="tab"
          row={true}
          options={inviteUserTypes}
          isCircularRadio={true}
          className="invite-user-form-radio-group"
        />

        <Stack spacing={3} mt={2}>
          {apiError && <Alert severity="error">{apiError}</Alert>}

          {tab === "internalUser" ? (
            <Stack spacing={1}>
              <RFHAutocomplete
                name="user"
                label={"Select User"}
              options={userOptions}/>
              {/* <p style={{ color: "red" }}>{formState.errors?.user?.message}</p> */}
            </Stack>
          ) : (
            <Stack spacing={3}>
              <RFHTextField
                name="first_name"
                label={"First Name"}
                required
                fullWidth
                className="invite-user-form-text-field"
              />

              <RFHTextField
                name="last_name"
                label={"Last Name"}
                required
                fullWidth
                className="invite-user-form-text-field"
              />

              <RFHTextField
                name="email"
                label={"Email Address"}
                required
                fullWidth
                className="invite-user-form-text-field"
              />
            </Stack>
          )}
          <Box
            sx={{
              alignSelf: "end",
            }}
            className="invite-user-form-button-container d-flex"
          >
            <CustomButton
              type="submit"
              variant="contained"
              className="invite-user-form-submit-button"
              disabled={loading}
            >
              Add
            </CustomButton>
            <CustomButton
              variant="outlined"
              className="invite-user-form-cancel-button"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </CustomButton>
          </Box>
        </Stack>
      </Box>
    </FormProvider>
  );
}

export default React.memo(InviteUserForm);
